import { createClient } from '@supabase/supabase-js';

// Points at the iOS app's Supabase project (set in .env)
const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Requests carry the Clerk session token when someone is signed in (the admin
// dashboard), so RLS admin policies can verify who's asking. Visitors on the
// public waitlist page are signed out -> token null -> anon role, which RLS
// only permits to insert/update waitlist rows.
export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  accessToken: async () => {
    try {
      return (await window.Clerk?.session?.getToken()) ?? null;
    } catch {
      return null;
    }
  },
});
